// ═══════════════════════════════════════════════════════════════
// Rince water-badge — geladen via theme.liquid.
// Bronvolgorde per badge: (1) waterchecker-uitslag uit localStorage,
// (2) postcode van het ingelogde account via hxFind/hxAssess uit
// rince-waterchecker.js, (3) uitnodiging (of verbergen).
// Een MutationObserver vangt badges die later in de DOM verschijnen:
// Horizon her-rendert de cart-drawer bij elke cart-update en morpht
// secties in de editor, dus init op page-load alleen is niet genoeg.
// ═══════════════════════════════════════════════════════════════

(function () {
  'use strict';
  var KEY = 'rince_water';

  function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

  function show(root, visible) {
    var wrap = root.closest('[data-wb-wrap]') || root;
    wrap.style.display = visible ? '' : 'none';
  }

  function render(root, res, bron) {
    var textEl = root.querySelector('[data-wb-text]');
    if (!textEl) return;
    var chipEl = root.querySelector('[data-wb-chip]');
    var srcEl = root.querySelector('[data-wb-source]');
    var linkEl = root.querySelector('[data-wb-link]');
    var dH = res.min === res.max ? fmt(res.min) : fmt(res.min) + '–' + fmt(res.max);
    var tpl = root.dataset.textKnown || 'Jouw water in {plaats}: {label} ({dH} °dH)';
    textEl.textContent = tpl
      .replace('{plaats}', res.display)
      .replace('{label_klein}', String(res.label).toLowerCase())
      .replace('{label}', res.label)
      .replace('{dH}', dH);
    if (chipEl) { chipEl.textContent = res.label; chipEl.hidden = false; }
    var srcText = bron === 'account' ? (root.dataset.sourceAccount || '') : (root.dataset.sourceChecker || '');
    if (bron === 'voorbeeld') srcText = 'Voorbeeldweergave';
    if (srcEl) { srcEl.textContent = srcText; srcEl.hidden = !srcText; }
    if (linkEl) {
      // context zonder bekende-CTA (cart): link verdwijnt zodra er een uitslag is
      if (root.dataset.ctaKnown) { linkEl.textContent = root.dataset.ctaKnown; linkEl.hidden = false; }
      else linkEl.hidden = true;
    }
    root.classList.add('is-known');
    root.dataset.hardness = String(res.label || '').toLowerCase(); // 'zacht' | 'middel' | 'hard' — voor kleur in de gallery-badge
    show(root, true);
  }

  function fromStorage() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (d && d.display && d.label && typeof d.min === 'number') return d;
    } catch (e) { /* stil */ }
    return null;
  }

  function fromCustomer(root) {
    if (!window.hxFind || !window.hxAssess) return null;
    var zip = (root.dataset.custZip || '').trim();
    var cc = (root.dataset.custCountry || '').toUpperCase();
    if (!zip || (cc && cc !== 'NL' && cc !== 'BE')) return null;
    var m4 = zip.match(/\d{4}/);
    if (!m4) return null;
    var m = window.hxFind(m4[0], cc === 'BE' ? 'BE' : 'NL');
    if (!m) return null;
    var a = window.hxAssess(m);
    return { display: m.display, country: m.country, min: m.min, max: m.max, category: a.category, label: a.label };
  }

  function resolve(root, pogingen) {
    var res = fromStorage();
    if (res) return render(root, res, 'checker');
    if (root.dataset.custZip && !window.hxFind && pogingen > 0) {
      // rince-waterchecker.js laadt met defer; heel even wachten
      return setTimeout(function () { resolve(root, pogingen - 1); }, 250);
    }
    res = fromCustomer(root);
    if (res) return render(root, res, 'account');
    if (window.Shopify && window.Shopify.designMode) {
      return render(root, { display: 'Utrecht', min: 6.3, max: 7.6, label: 'Gemiddeld' }, 'voorbeeld');
    }
    if (root.dataset.hideUnknown) show(root, false);
  }

  function initAll() {
    document.querySelectorAll('[data-water-badge]:not([data-wb-init])').forEach(function (root) {
      root.setAttribute('data-wb-init', '1');
      resolve(root, 20);
    });
  }

  // Eén luisteraar voor alle badges: doet de bezoeker ergens op de
  // pagina de waterchecker, dan volgen alle badges direct.
  document.addEventListener('rince:water', function (e) {
    if (!e.detail) return;
    document.querySelectorAll('[data-water-badge]').forEach(function (root) {
      render(root, e.detail, 'checker');
    });
  });

  function boot() {
    initAll();
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          // nieuwe nodes (drawer her-render) of een gestripte init-marker (morph)
          if ((muts[i].addedNodes && muts[i].addedNodes.length) || muts[i].type === 'attributes') {
            initAll();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-wb-init'] });
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
